export enum DistributionOfLandedCostsRuleEnum {
    AccordingToTheAmount,
    AccordingToTheQuantity,
    AccordingToTheWeight,
}